
import {doc} from '../docs.js';

const EPSILON = 0.00001;

doc(
    "list.matrixMultiplyList",
    {
        "list of matrices (1&2)":"",
    },
    "Takes 2 lists and multiples each pair of matrices together into a new list",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);
export const matrixMultiplyList = (object) => {
    return ([c]) => {
        let [a,_b] = c;
        if (!a && _b) {
            return [_b];
        }
        if (!_b) {
            return [a];
        }
        let list = [];

        for (let i=0; i < a.length; i++) {
            let matrixA = a[i];
            let matrixB = _b[i];
            if (!matrixA || !matrixB) {
                continue;
            }
            let product = m_mult(matrixA, matrixB);
            list.push(product);
        }
        return [list];
    };
};

doc(
    "list.matrixMultiply",
    {
        "list of matrices 1":"",
        "matrix of matrices 2": ""
    },
    "Takes 2 lists and multiples each pair of matrices together into a new list",
    () => 1,
    {
        isHot: true,
        inlets: 2
    }
);
export const matrixMultiply = (object, b) => {
    return ([a]) => {
        let _b = b();
        if (!a && _b) {
            return [_b];
        }
        if (!_b) {
            return [a];
        }
        let list = [];

        for (let i=0; i < a.length; i++) {
            let matrixA = a[i];
            let matrixB = _b[i];
            if (!matrixA || !matrixB) {
                continue;
            }
            let product = m_mult(matrixA, matrixB);
            list.push(product);
        }
        return [list];
    };
};


function m_mult(a, b) {
  var aNumRows = a.length, aNumCols = a[0].length,
      bNumRows = b.length, bNumCols = b[0].length,
      m = new Array(aNumRows);  // initialize array of rows
  for (var r = 0; r < aNumRows; ++r) {
    m[r] = new Array(bNumCols); // initialize the current row
    for (var c = 0; c < bNumCols; ++c) {
      m[r][c] = 0;             // initialize the current cell
      for (var i = 0; i < aNumCols; ++i) {
        m[r][c] += a[r][i] * b[i][c];
          if (Math.abs(m[r][c] - 0) < EPSILON) {
              m[r][c] = 0;
          }
      }
    }
  }
  return m;
}

doc(
    "list.allIdentity",
    {
        "list of matrices 1":"",
    },
    "Takes 2 lists and multiples each pair of matrices together into a new list",
    () => 1,
);
export const allIdentity = (object) => {
    return ([msg]) => {
        if (!Array.isArray(msg)) {
            return;
        }
        if (msg.every(x => isIdentity(x))) {
            return [0];
        }
        return [msg];
    };
};

const isIdentity = (mat) => {
    let [a,b,c] = mat;
    return a[0] === 1 && a[1] === 0 && a[2] === 0 &&
        b[0] === 0 && b[1] === 1 && b[2] === 0 &&
        c[0] ===0 && c[1] === 0 && c[2] === 1;
};

export const matrixOperations = {
    "list.matrixMultiply" : matrixMultiply,
    "list.matrixMultiplyList" : matrixMultiplyList,
    "list.allIdentity" : allIdentity
};

